import {ValueObject} from '@s-ui/domain'

export default class BreadcrumbRequestValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Number} param.offerTypeId
   * @param {Number} param.category1Id
   * @param {Number} param.category2Id
   * @param {Number} param.bodyTypeId
   * @param {Number} param.makeId
   * @param {Number} param.modelId
   * @param {Number} param.provinceId
   * @param {String} param.version
   */
}
